import { render, staticRenderFns } from "./ChildTreeTable.vue?vue&type=template&id=e70880e8"
import script from "./ChildTreeTable.vue?vue&type=script&lang=ts"
export * from "./ChildTreeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports